import React, { useState, useContext, useEffect, useRef } from 'react';
import {
  Grid,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@mui/material';

import { useNavigate } from 'react-router-dom';
import { AppContext } from '../../context/Context';

import { SocketContext } from '../../context/SocketContext';
import { useTranslation } from 'react-i18next';
import Select, { components } from 'react-select';
import Skeleton from '@mui/material/Skeleton';

function TableLoader() {
  return (
    <Table
      sx={{ color: 'white', background: '#1f2c67' }}
      stickyHeader
      aria-label="skeleton table"
    >
      <TableHead sx={{ background: '#1f2c67' }}>
        <TableRow>
          {[
            'Time',
            'User ID',
            'Username',
            'Name',
            'Total',
            'Provider',
            'Description',
            'Ticket Sale ID',
          ].map((header, index) => (
            <TableCell key={index} align="center">
              <Skeleton variant="text" width="80%" height={30} />
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {Array.from(new Array(18)).map((_, rowIndex) => (
          <TableRow
            key={rowIndex}
            sx={{
              '&:nth-of-type(odd)': { backgroundColor: '#232a45' },
              '&:nth-of-type(even)': { backgroundColor: '#1a2036' },
            }}
          >
            {Array.from(new Array(8)).map((__, colIndex) => (
              <TableCell key={colIndex} align="center">
                <Skeleton variant="text" width="80%" height={30} />
              </TableCell>
            ))}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}

export default TableLoader;
